import JsFileDownload from 'js-file-download'

import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'

function ReportHook() {
  const onDownloadReport = async (values: any) => {
    try {
      const rangeDate = values.rangeDate
      const startDate = rangeDate[0].startOf('day').toISOString()
      const endDate = rangeDate[1].endOf('day').toISOString()
      const isMapped = values.isMapped

      const downloadUrl = `${config.restUrl}/v1/report/ppu-motor-tvi-connect-devices?startDate=${startDate}&endDate=${endDate}&isMapped=${isMapped}`
      const { data } = await httpClientPrivate.get(downloadUrl)

      JsFileDownload(data, 'report.csv')
    } catch (err) {
      console.log(err)
    }
  }

  return {
    onDownloadReport,
  }
}

export default ReportHook
